module.exports = __webpack_public_path__ + "static/learn-remember-apply-a740d54e816ce3b05d959f776876ff95.webp";